import PropTypes from "prop-types";
import {useRef} from "react";
import useNavbar from "lib/hooks/use-navbar";
import NavLink from "./link";

function Navbar({color = "dark", home = null, links}) {
  const ref = useRef(null);
  const {toggleMenu} = useNavbar({ref});

  return (
    <nav className={`navbar navbar-expand-lg navbar-dark bg-${color}`} ref={ref}>
      {home && (<a className="navbar-brand" href={home.path}>{home.name}</a>)}
      <button className="navbar-toggler" type="button" aria-label="Toggle navigation" onClick={toggleMenu}>
        <i className="fas fa-bars" />
      </button>
      <div className="collapse navbar-collapse">
        <ul className="navbar-nav ml-auto">
          {links.map(({active, name, path}) => (
            <li key={name}>
              <NavLink active={active} to={path}>{name}</NavLink>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}

Navbar.propTypes = {
  color: PropTypes.string,
  home: PropTypes.shape({
    name: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired
  }),
  links: PropTypes.arrayOf(
    PropTypes.shape({
      active: PropTypes.bool,
      name: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired
    }).isRequired
  ).isRequired
};

export default Navbar;
